var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3848 0H12.0774L19.4448 7.67917V22.6152C19.4448 24.4863 17.931 26 16.0664 26H3.3848C1.51374 26 5.34685e-10 24.4863 5.34685e-10 22.6152V3.3848C-3.28504e-05 1.51374 1.5137 0 3.3848 0Z",
    fill: "#E5252A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0713 0V7.62069H19.4451L12.0713 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.76221 19.3994V14.6502H5.7827C6.28296 14.6502 6.67927 14.7867 6.97812 15.066C7.27696 15.3389 7.4264 15.7092 7.4264 16.1705C7.4264 16.6317 7.27696 17.0021 6.97812 17.2749C6.67927 17.5543 6.28296 17.6907 5.7827 17.6907H4.9771V19.3994H3.76221ZM4.9771 16.6578H5.64627C5.82817 16.6578 5.9711 16.6188 6.06857 16.5278C6.16601 16.4434 6.21801 16.3264 6.21801 16.1705C6.21801 16.0146 6.16604 15.8977 6.06857 15.8132C5.97114 15.7222 5.8282 15.6833 5.64627 15.6833H4.9771V16.6578ZM7.92662 19.3994V14.6502H9.60928C9.94061 14.6502 10.2525 14.6957 10.5448 14.7932C10.8371 14.8906 11.1035 15.0271 11.3374 15.2155C11.5713 15.3974 11.7597 15.6442 11.8961 15.9561C12.0261 16.2679 12.0975 16.6253 12.0975 17.0281C12.0975 17.4244 12.0261 17.7817 11.8961 18.0935C11.7597 18.4054 11.5713 18.6522 11.3374 18.8341C11.1035 19.0225 10.8371 19.159 10.5448 19.2564C10.2525 19.3539 9.94061 19.3994 9.60928 19.3994H7.92662ZM9.11553 18.3664H9.46634C9.65474 18.3664 9.83017 18.3469 9.99258 18.3014C10.1485 18.256 10.2979 18.1845 10.4409 18.087C10.5773 17.9896 10.6877 17.8531 10.7657 17.6712C10.8436 17.4893 10.8826 17.2749 10.8826 17.0281C10.8826 16.7747 10.8436 16.5603 10.7657 16.3784C10.6877 16.1965 10.5773 16.0601 10.4409 15.9626C10.2979 15.8652 10.1485 15.7937 9.99258 15.7482C9.83017 15.7027 9.65474 15.6832 9.46634 15.6832H9.11553V18.3664ZM12.7082 19.3994V14.6502H16.0866V15.6832H13.9231V16.4433H15.6513V17.4698H13.9231V19.3994H12.7082Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.19a3374bf33cf0c5cf31f29e6509e2d9.svg";
export { ForwardRef as ReactComponent };